import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

import Ionic from '@ionic/vue'
import '@ionic/core/css/core.css'
import '@ionic/core/css/ionic.bundle.css'

Vue.use(Ionic)

// Fontawesome Init
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    faCheckCircle,
    faBell,
    faExclamationCircle,
    faTimesCircle,
    faBellSlash,
    faEdit
} from '@fortawesome/free-solid-svg-icons'
library.add(faCheckCircle)
library.add(faBell)
library.add(faExclamationCircle)
library.add(faTimesCircle)
library.add(faBellSlash)
library.add(faEdit)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false


// axios
import axios from 'axios'
Vue.prototype.$http = axios

// ionic-storage
import { Drivers, Storage } from '@ionic/storage';
const storage = new Storage({
    name: '__mydb',
    driverOrder: [Drivers.IndexedDB]
});

storage.create().then(res => {
    Vue.prototype.$ionicStorage = res
})

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuesax Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// // Google Maps
// import * as VueGoogleMaps from 'vue2-google-maps'
// Vue.use(VueGoogleMaps, {
//     load: {
//         // Add your API key here
//         key: 'YOUR_API_KEY',
//         libraries: 'places', // This is required if you use the Auto complete plug-in
//     },
// })

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// Register Service Worker
import './registerServiceWorker'

// Sentry
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

if(process.env.NODE_ENV == 'production') {
    Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [new Integrations.BrowserTracing({Vue, attachProps: true})],
        release: store.state.version,
        environment: process.env.NODE_ENV
    });
}

// Google Analytics
// import VueGtag from "vue-gtag";
// if(process.env.NODE_ENV == 'production') {
//     Vue.use(VueGtag, {
//         config: { id: "VALUE" }
//     }, router);
// }

// quill settings
import Quill from 'quill'

const quill_attributors = Object.keys(Quill.imports).filter(v => v.startsWith('attributors'))
quill_attributors.forEach(attributor => Quill.register(Quill.import(attributor), true))

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')
